$(document).on("turbolinks:load", function () {

  if ($('#js-intake-template-form').is('*')){
    bindFieldTypeChange();
    bindModelTypeChange();
    bindDataTypeChange();
    bindOptionChanges();
    bindDataTypeRemoval();

    $('.js-custom-fields').each( function(){
      var fields_container = $(this);

      var model_type_select = fields_container.find('select.js-form-model-type-select');
      var field_type_select = fields_container.find('select.js-intake-data-type-select');
      var dataTypeSelect = fields_container.find('select.js-custom-data-field-select');
  
      if(dataTypeSelect) {
        updateDataTypeSelect(dataTypeSelect, model_type_select.val(), field_type_select.val(), true);
      }
    })
  }
});

function bindFieldTypeChange() {
  $('body').on('change', 'select.js-form-field-type-select', function() {
    var fields_container = $(this).parents('.js-input-field-container').find('.js-custom-fields');

    if ($(this).val() === 'custom') {
      fields_container.find('input, select').prop('disabled', false);
      fields_container.find('select').selectpicker('refresh');
      fields_container.show();
    } else {
      fields_container.hide();
      fields_container.find('input, select').prop('disabled', true);
      fields_container.find('select').selectpicker('refresh');
    }
  });
}

function bindModelTypeChange() {
  $('body').on('change', 'select.js-form-model-type-select', function() {
    var fields_container = $(this).parents('.js-custom-fields');
    var field_type_select = fields_container.find('select.js-intake-data-type-select');

    field_type_select.val('');
    field_type_select.find('option').prop('disabled', false);
    field_type_select.selectpicker('refresh');

    if ($(this).val() === 'client') {
      field_type_select.find('option[data-type="vaccine"]').prop('disabled', true);
    } else {
      field_type_select.find('option[data-type="address"]').prop('disabled', true);
    }

    field_type_select.selectpicker('refresh');
  });
}

function bindDataTypeChange() {
  $('body').on('change', 'select.js-form-model-type-select, select.js-intake-data-type-select', function() {
    var fields_container = $(this).parents('.js-custom-fields');

    var model_type_select = fields_container.find('select.js-form-model-type-select');
    var field_type_select = fields_container.find('select.js-intake-data-type-select');
    var dataTypeSelect = fields_container.find('select.js-custom-data-field-select');

    if(dataTypeSelect) {
      updateDataTypeSelect(dataTypeSelect, model_type_select.val(), field_type_select.val());
    }
  });
}

function updateDataTypeSelect(select, model, dataType, skipReset=false) {
  if (!skipReset) {
    select.val('').trigger('change');
  }
  select.find('option').prop('disabled', true)
  select.find('option[data-model-type="'+model+'"][data-type="'+dataType+'"]').prop('disabled', false);
  select.selectpicker('refresh');

  if(dataType == 'single_option' || dataType == 'multiple_option') {}
}

function bindOptionChanges() {
  $('body').on('change', 'select.js-custom-data-field-select, select.js-intake-data-type-select', function() {
    var fields_container = $(this).parents('.js-custom-fields');

    var dataType = fields_container.find('select.js-custom-data-field-select').val();
    var optionsContainer = fields_container.find('.js-intake-field-options');

    if(!dataType) {
      fields_container.find('.js-remove-data-intake-field').val(true);
    } else {
      fields_container.find('.js-remove-data-intake-field').val('');
    }

    if(optionsContainer){
      if(dataType == 'single_option' || dataType == 'multiple_option') {
        optionsContainer.hide();
        optionsContainer.find('input').prop('disabled', true);
  
      } else if (!dataType) {
        var field_type_select = fields_container.find('select.js-intake-data-type-select');
        var parentDataType = field_type_select.val();

        if (parentDataType == 'single_option' || parentDataType == 'multiple_option') {
          optionsContainer.find('input').prop('disabled', false);
          optionsContainer.show();
        } else {
          optionsContainer.hide();
          optionsContainer.find('input').prop('disabled', true);
        }
      }  
    }
  });
}

function bindDataTypeRemoval() {
  $('body').on('click', '.js-remove-data-link', function(e) {
    e.preventDefault();
    var fields_container = $(this).parents('.js-custom-fields');

    fields_container.find('select.js-custom-data-field-select').val('').trigger('change');
  });

  $('body').on('change', '.js-custom-data-field-select', function() {
    var valuesSelect = $(this);
    var deleteField = valuesSelect.parents('.js-custom-fields').find('js-remove-data-intake-field');

    if (valuesSelect.val()) {
      deleteField.val('');
    } else {
      deleteField.val(true);
    }

  });
}
